import axios from 'axios'
import { CardValidation, CardValidationResponse } from './_models'

const API_URL = process.env.REACT_APP_API_URL
const API_SERVICE_URL = process.env.REACT_APP_SERVICE_API_URL

export const CARDVALIDATION_URL = `${API_SERVICE_URL}/CardRequest/ValidateCard`

export function verifyCode(code : string) {
  return axios.get<CardValidationResponse>(CARDVALIDATION_URL, { params: { code: code } })
}